import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions'
import { auth } from '../../../services/auth.service';

export const GET_MEMBERSHIP_USERS = 'GET_MEMBERSHIP_USERS';
export const GET_MEMBERSHIP_USERS_DETAILS = 'GET_MEMBERSHIP_USERS_DETAILS'
export const UPDATE_MEMBERSHIP_USER = 'UPDATE_MEMBERSHIP_USER';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchMembershipUsers() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageMembershipUsers/GetMembershipUsers`, { headers: auth.authHeader() })
			.then((response) => {
				if (response && response.data && response.data.isSuccess) {
                    dispatch({
                        type: GET_MEMBERSHIP_USERS,
                        payload: response.data.membershipUsers
                    });
                }
                else {
					var err = response && "Error Receiving Membership Users"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function fetchMembershipUsersByUser(userId, membershipAssignmentId) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageMembershipUsers/GetMembershipsByUser?userId=${userId}&membershipAssignmentId=${membershipAssignmentId}`, { headers: auth.authHeader() })
			.then((response) => {
				if (response && response.data && response.data.isSuccess) {
            dispatch({
                type: GET_MEMBERSHIP_USERS_DETAILS,
                payload: response.data.membershipUsersDetails
            });
        } else {
					var err = response && "Error Receiving Membership Users"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}


export function updateMembershipUser(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageMembershipUsers/UpdateMembershipUser`, model, { headers: auth.authHeader() })
			.then((response) => {
				if (response && response.data && response.data.isSuccess) 
				{
					dispatch({
						type: UPDATE_MEMBERSHIP_USER,
						payload: response.data.membershipUsers
					});	
					var success = response && response.data ? response.data.message : "Membership User Updated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}
